<p-toast position="top-right" [life]="6000" key="tl"></p-toast>

<!-- Top option bar-->
<p-steps  class="ui-grid-responsive steps" [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"
         (click)="goBackSteps(activeIndex)"  styleClass="executions.component.css">
</p-steps>

<h5>{{header}}</h5>

<!-- Separation Line --->
<hr class="style-four">
<div >

  <div [hidden]="resourceButtons" class="ExecButtons" >
    <div *ngFor="let resource of resources;" class="ui-g-4 ui-lg-3">
      <button class="w3-btn w3-ripple" type="button" (click)="resourceClicked(resource.value)">
        {{resource.value}}
      </button>
    </div>
  </div>


  <div [hidden]="applicationButtons" class="ExecButtons">
    <div *ngFor="let application of applications;" class="ui-g-4 ui-lg-3">
      <button class="w3-btn w3-ripple" type="button" (click)="applicationClicked(application .value)">
        {{application .value}}
      </button>
    </div>
  </div>

  <div [hidden]="locationButtons" class="ExecButtons">
    <div *ngFor="let location of locations;" class="ui-g-4 ui-lg-3">
      <button class="w3-btn w3-ripple" type="button"  (click)="locationClicked(location.value)">
        {{location.value}}
      </button>
    </div>
  </div>

  <div [hidden]="jobButtons" class="ExecButtons">
    <div *ngFor="let job of jobnames;" class="ui-g-4 ui-lg-3">
      <button class="w3-btn w3-ripple" type="button" (click)="jobClicked(job.value)">
        {{job.value}}
      </button>
    </div>
  </div>

<p-progressSpinner [hidden]="progressSpinner" class="p-spinner" [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>


<div style="margin-top: 30px">
  <div  id="cardDiv" [hidden]="ExecutionCard"  style="clear: left;" >
    <div style="margin-bottom: 10px; margin-top: 20px;">
      <button class="margin" type="button" pButton label="Go Back" (click)="goBack()"  >
      </button>
    </div>
  <app-execution-details *ngIf="jobDetails"></app-execution-details>
</div>
</div>
</div>
